import script from "./list-hall.vue?vue&type=script&setup=true&lang=js"
export * from "./list-hall.vue?vue&type=script&setup=true&lang=js"

import "./list-hall.vue?vue&type=style&index=0&id=65eb56f3&scoped=true&lang=css"
import "./list-hall.vue?vue&type=style&index=1&id=65eb56f3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65eb56f3"]])

export default __exports__